import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LanguageService } from 'sham-components/services';
import { ShamLanguageSquareIcon } from 'sham-components/icons';

@Component({
  selector: 'language-switcher',
  imports: [ShamLanguageSquareIcon],
  templateUrl: './language-switcher.html',
  styles: `
    .language-trigger { display: inline-flex; min-height: 2rem; align-items: center; gap: 0.5rem; border: 0; border-radius: 0.375rem; padding: 0 0.75rem; background: #2192ba; color: #fff; font: inherit; font-size: 0.875rem; font-weight: 600; cursor: pointer; }
    .language-trigger:hover, .language-trigger:focus-visible { background: #176b88; outline: none; }
    :host(.dashboard-language-switcher) { display: inline-block; }
    :host(.dashboard-language-switcher) .language-trigger { position: relative; width: 2rem; height: 2rem; min-height: 0; justify-content: center; border: 1px solid #e7eae9; border-radius: 8px; padding: 0; background: #ffffff; color: #191c1f; transition: transform 200ms ease; }
    :host(.dashboard-language-switcher) .language-trigger:hover, :host(.dashboard-language-switcher) .language-trigger:focus-visible { transform: scale(1.05); background: #ffffff; outline: 1px solid #2192ba; outline-offset: 1px; }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherComponent {
  readonly lang = inject(LanguageService);

  toggleLanguage() {
    this.lang.toggleLanguage();
  }
}
